// extracted by mini-css-extract-plugin
module.exports = {"container":"Pivots-module--container--2-SkU","list":"Pivots-module--list--1mFfX","subtitle":"Pivots-module--subtitle--3fZ69"};